module.exports = __webpack_public_path__ + "static/img/CourtneyCramey.4d88cb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CourtneyCramey.jpg
// module id = XqDx
// module chunks = 0